class ShowMorePagination extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    if (this.button) {
      this.button.addEventListener("click", this.onButtonClick.bind(this));
    }
    this.productsContainer = document.getElementById("product-grid");
    this.loadingSpinner = this.querySelector(".loading-spinner");
    this.currentPage = 1;
  }

  onButtonClick() {
    this.currentPage++;
    this.button.disabled = true;
    this.loadingSpinner.classList.remove("hidden");

    let url;
    if (window.customCollectionHandle) {
      url = new URL(
        `/collections/${window.customCollectionHandle}`,
        window.location.origin
      );
    } else {
      url = new URL(window.location.href);
    }

    const query = url.searchParams.get('q');

    // Get the URL for the next page
    url.searchParams.set("page", this.currentPage);
    url.searchParams.set("section_id", this.dataset.sectionId);

    const productCountDesktop = document.getElementById('ProductCountDesktop');
    const productCountMobile = document.getElementById('ProductCount');

    if (!productCountDesktop) return;

    const productCount = Number(productCountDesktop.dataset?.count || 0);
    const productAllCount = Number(productCountDesktop.dataset?.allCount || 0);
    const productAllPages = Number(productCountDesktop.dataset?.pages || 0);
    const productCountTemplate = productCountDesktop.dataset.template;
    
    if (this.currentPage > productAllPages) return;

    // Fetch the next page content
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const productGrid = html.getElementById('product-grid');

        // Check if this was the last page
        const nextPageExists =
          html.querySelector("show-more-pagination") !== null;

        // Append new products to the grid
        if (this.productsContainer) {
          const productItems = html.querySelectorAll('#product-grid .grid__item');
  
          if (!query) {
            const newText = productCountTemplate.replace("PRODUCT_COUNT", productCount + productItems.length).replace("ALL_COUNT", productAllCount);
            productCountDesktop.textContent = newText;

            if (productCountMobile) productCountMobile.textContent = newText;
          }

          if (query) {
            productGrid.querySelectorAll("li.grid__item").forEach(item => {
              item.style.display = "none";
            });
          }

          this.productsContainer.insertAdjacentHTML('beforeend', productGrid.innerHTML);
        }

        // Re-enable the button if there are more pages
        this.button.disabled = false;
        this.loadingSpinner.classList.add("hidden");

        // Hide button if it was the last page
        if (!nextPageExists) {
          this.classList.add("hidden");
          this.productsContainer.classList.add("product-grid--no-pagination");
        }

        // Initialize any product card functionality that might be needed
        if (typeof window.initializeComponents === "function") {
          window.initializeComponents();
        }
      })
      .catch(e => {
        console.error(e);
        this.button.disabled = false;
        this.loadingSpinner.classList.add("hidden");
      });
  }
}

customElements.define("show-more-pagination", ShowMorePagination);
